import * as CActions from 'ApplicationEntry/ducks/ProductsRiders/cancer';
import * as C from 'ApplicationEntry/models/ProductsRiders/Cancer/NewYorkCancer';
import * as ErrorMessages from '../../ErrorMessages';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import './../ProductRiders.sass';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';

type CancerProps = {
  cancer: C.NewYorkCancer;
};

const Cancer = (props: CancerProps) => {
  const dispatch = useDispatch();
  const {planType, calculatedPremium, riderInformation, cwa, section125, policyOption} = props.cancer;
  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [policyOptionBlurred, setBlurPolicyOption] = useState(false);
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [policyOptionLabel, setPolicyOptionLabel] = useState<HTMLLabelElement | null>();
  const showPolicyOptionError = policyOptionBlurred && policyOption.key === 'Empty';
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';

  return (
    <>
      <div className="product-riders-section__policy-type" id="cancer-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPolicyOptionError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPolicyOptionLabel} id="cancer-policy-option-label">
                    Policy Option
                  </InputLabel>
                  <Select
                    labelId="cancer-label--policy-option"
                    labelWidth={policyOptionLabel?.clientWidth}
                    id="cancer-policy-option"
                    value={policyOption.key === 'Empty' ? '' : policyOption.value}
                    onBlur={() => setBlurPolicyOption(true)}
                    onChange={event => dispatch(CActions.changePolicyOption(event.target.value as string))}
                    displayEmpty
                  >
                    {C.policyOptions.map(policyOption => (
                      <MenuItem value={policyOption} key={policyOption}>
                        {policyOption}
                      </MenuItem>
                    ))}
                  </Select>
                  {showPolicyOptionError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanTypeError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanTypeLabel} id="cancer-plan-type-label">
                    Plan Type
                  </InputLabel>
                  <Select
                    labelId="cancer-label-plan-type"
                    labelWidth={planTypeLabel?.clientWidth}
                    id="cancer-plan-type"
                    value={planType.key === 'Empty' ? '' : planType.value}
                    onBlur={() => setBlurPlanType(true)}
                    onChange={event => {
                      dispatch(CActions.changePlanType(event.target.value as string));
                    }}
                  >
                    <MenuItem value="IND">Individual</MenuItem>
                    <MenuItem value="FAMILY">Family</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="cancer-section-125"
                      checked={section125}
                      onChange={() => dispatch(CActions.changeSection125(!section125))}
                    />
                  }
                  label={<Typography>Section 125</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="cancer-premium"
                  label="Premium"
                  variant="outlined"
                  placeholder="Enter Premium"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={calculatedPremium.value}
                  required={section125}
                  onChange={event => {
                    dispatch(CActions.changePremium(event.target.value as string));
                    dispatch(CActions.changeCalculatedPremium(event.target.value as string));
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="cancer-cwa"
                  label="CWA"
                  variant="outlined"
                  placeholder="Enter CWA"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={cwa.value}
                  onChange={event => dispatch(CActions.changeCWA(event.target.value as string))}
                />
              </Grid>
            </Grid>

            <FixedCodeRiderInformation
              riderInformation={riderInformation}
              changeRiderInformationAction={CActions.changeRiderInformation}
              identifier={'new-york-cancer'}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default Cancer;
